import { Roles } from '@shs-digi-care-monorepo/interfaces';
import { NamFeature, FeatureConfig } from './nam-feature.model';
import { Stage } from '@shs-digi-care-monorepo/frontend-lib/enums';

/**
 * Role presets
 */
/** Stream-level NAM admin only. */
export const ADMIN = [Roles.ADMIN];

/** Roles that work on tasks. */
export const TASK_OWNER = [Roles.ADMIN, Roles.TASK_OWNER];

/**
 * Central feature configuration map.
 * Each entry defines the roles (and optionally the stages) for which a feature is enabled.
 *
 * To add a new role-gated feature:
 * 1. Add an entry to the `NamFeature` enum
 * 2. Add the corresponding config here
 * 3. Use `NamFeatureService.isEnabled(NamFeature.YOUR_FEATURE)` in components
 */
export const FEATURE_CONFIG: Record<NamFeature, FeatureConfig> = {
    [NamFeature.ADMIN_AREA]: {
        roles: ADMIN
    },
    [NamFeature.ALL_REQUESTS]: {
        roles: TASK_OWNER
    },
    [NamFeature.REAGENT_ORDERS]: {
        roles: [],
        disabledOnStages: [Stage.PROD]
    },
    [NamFeature.ALLOCATION]: {
        roles: TASK_OWNER,
        includeInternalUsers: true
    },
    [NamFeature.SATURDAY_DELIVERY]: {
        roles: TASK_OWNER,
        includeInternalUsers: true
    },
    [NamFeature.MATERIAL_AND_PRICING]: {
        roles: TASK_OWNER,
        includeInternalUsers: true
    },
    [NamFeature.PROFILE_DETAILS]: {
        roles: TASK_OWNER,
        includeInternalUsers: true
    },
    [NamFeature.USER_SETTINGS]: {
        roles: TASK_OWNER
    },
    [NamFeature.APPLICATION_SETTINGS]: {
        roles: ADMIN
    },
    [NamFeature.OUT_OF_OFFICE]: {
        roles: TASK_OWNER
    },
    [NamFeature.OUT_OF_OFFICE_CALENDAR]: {
        roles: TASK_OWNER
    }
};
